import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { ITabConfiguration, ITabProps, ITabState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { TAB_CATEGORY_KEY, TAB_COMPONENT_KEY } from './Tab.meta.js';

export class Tab extends ComponentBase<ITabProps, ITabState, ITabConfiguration> {
	categoryKey = TAB_CATEGORY_KEY;
	componentKey = TAB_COMPONENT_KEY;

	constructor(props: ITabProps) {
		super(props);
	}
	render() {
		const { className, children } = this.props;
		return <Wrapper className={className}>{children}</Wrapper>;
	}
}

export default InjectedStyledComponent(observer(Tab), TAB_CATEGORY_KEY, TAB_COMPONENT_KEY);
